"use strict";
// https://github.com/facebook/jest/issues/7547
Object.defineProperty(exports, "__esModule", { value: true });
exports.assert = void 0;
const assert = (value, error) => {
    if (!value) {
        // https://github.com/typescript-eslint/typescript-eslint/issues/3814
        // eslint-disable-next-line @typescript-eslint/no-throw-literal
        throw error;
    }
};
exports.assert = assert;
